export default {
  search_placeholder: "Buscar preguntas frecuentes...",
  no_results_title: "No se encontraron resultados",
  no_results_subtitle:
    "Intente ajustar sus términos de búsqueda o explore las categorías de la izquierda.",
  search_cleared_message: "Búsqueda eliminada para mostrar contenido completo",
  still_have_questions: {
    before_email: "¿Tiene más preguntas? Contáctenos en ",
    after_email: " — nuestro equipo responderá dentro de 24 horas.",
  },
};
